// extracted by mini-css-extract-plugin
export default {"title":"RegistrationSection_title__QO5mA","regnInfoText":"RegistrationSection_regnInfoText__zLTSb","jumbo":"RegistrationSection_jumbo__6cYqs"};